module.exports = __webpack_public_path__ + "static/media/app_icon.66cd1259.png";